var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo } from 'react';
import useThunkReducer from 'react-hook-thunk-reducer';
import { ShiftTypeFilterInitialState } from '../../features/ShiftFilters/ShiftFilters/ShiftTypeFilter/ShiftTypeFilterTypes';
import { UnavailableShiftFilterInitialState, UnavailableShiftTranslationKeys } from '../../features/ShiftFilters/ShiftFilters/UnavailableShiftFilter/UnavailableShiftFilterTypes';
import { BIAnalytics } from '@amzn/atoz-shiftapp-utilities';
import { useDynamicTranslation } from '../../hooks';
export var UseShiftFilterActionType;
(function (UseShiftFilterActionType) {
    UseShiftFilterActionType["UpdateLocationFilter"] = "UPDATE_LOCATION_FILTER";
    UseShiftFilterActionType["UpdateTypeFilter"] = "UPDATE_TYPE_FILTER";
    UseShiftFilterActionType["UpdateUnavailableFilter"] = "UPDATE_UNAVAILABLE_FILTER";
    UseShiftFilterActionType["UpdateTimeStartFilter"] = "UPDATE_TIME_START_FILTER";
    UseShiftFilterActionType["UpdateTimeEndFilter"] = "UPDATE_TIME_END_FILTER";
    UseShiftFilterActionType["UpdateInitialState"] = "UPDATE_INITIAL_STATE";
    UseShiftFilterActionType["ResetFilters"] = "RESET_FILTERS";
})(UseShiftFilterActionType || (UseShiftFilterActionType = {}));
export var actionCreators = {
    updateLocationFilter: function (value) {
        return function (dispatch, getState) {
            var _a;
            BIAnalytics.updateLocationFilter();
            BIAnalytics.updateFilterOnFindShiftsPage();
            var filteredLocations = getState().filteredLocations;
            var currentValue = filteredLocations[value];
            dispatch({
                type: UseShiftFilterActionType.UpdateLocationFilter,
                payload: {
                    filteredLocations: __assign(__assign({}, filteredLocations), (_a = {}, _a[value] = !currentValue, _a))
                }
            });
        };
    },
    updateTypeFilter: function (value) {
        return function (dispatch, getState) {
            var _a;
            BIAnalytics.updateSurgePayFilter();
            BIAnalytics.updateFilterOnFindShiftsPage();
            var filteredTypes = getState().filteredTypes;
            var currentValue = filteredTypes[value];
            dispatch({
                type: UseShiftFilterActionType.UpdateTypeFilter,
                payload: {
                    filteredTypes: __assign(__assign({}, filteredTypes), (_a = {}, _a[value] = !currentValue, _a))
                }
            });
        };
    },
    updateJobTypesFilter: function (value) {
        return function (dispatch, getState) {
            var _a;
            BIAnalytics.updateJobCategoryFilter();
            BIAnalytics.updateFilterOnFindShiftsPage();
            var filteredJobTypes = getState().filteredJobTypes;
            var currentValue = filteredJobTypes[value];
            dispatch({
                type: UseShiftFilterActionType.UpdateLocationFilter,
                payload: {
                    filteredJobTypes: __assign(__assign({}, filteredJobTypes), (_a = {}, _a[value] = !currentValue, _a))
                }
            });
        };
    },
    updateUnavailableFilter: function (value) {
        return function (dispatch, getState) {
            var _a;
            BIAnalytics.updateUnavailabilityFilter();
            BIAnalytics.updateFilterOnFindShiftsPage();
            var filteredUnavailabilityOpts = getState().filteredUnavailabilityOpts;
            var prevSelectedValue = filteredUnavailabilityOpts[value];
            var prevAllValue = filteredUnavailabilityOpts[UnavailableShiftTranslationKeys.SHOW_ALL_UNAVAILABLE];
            var allValueSelected = value === UnavailableShiftTranslationKeys.SHOW_ALL_UNAVAILABLE;
            var newUnavailableFilters = {};
            // Auto-select the other options when "all" option is selected
            if (allValueSelected && !prevAllValue) {
                newUnavailableFilters[UnavailableShiftTranslationKeys.EXCEEDS_HOURS_CAP] = true;
                newUnavailableFilters[UnavailableShiftTranslationKeys.OVERLAPS_WITH_SCHEDULE] = true;
            }
            // uncheck "all option" if any other option unchecked
            if (!allValueSelected && prevSelectedValue) {
                newUnavailableFilters[UnavailableShiftTranslationKeys.SHOW_ALL_UNAVAILABLE] = false;
            }
            dispatch({
                type: UseShiftFilterActionType.UpdateUnavailableFilter,
                payload: {
                    filteredUnavailabilityOpts: __assign(__assign(__assign({}, filteredUnavailabilityOpts), newUnavailableFilters), (_a = {}, _a[value] = !prevSelectedValue, _a))
                }
            });
        };
    },
    updateTimeStartFilter: function (value) {
        return function (dispatch) {
            BIAnalytics.updateStartTimeFilter();
            BIAnalytics.updateFilterOnFindShiftsPage();
            dispatch({
                type: UseShiftFilterActionType.UpdateTimeStartFilter,
                payload: {
                    filteredStartTime: value
                }
            });
        };
    },
    updateTimeEndFilter: function (value) {
        return function (dispatch) {
            BIAnalytics.updateFilterOnFindShiftsPage();
            dispatch({
                type: UseShiftFilterActionType.UpdateTimeEndFilter,
                payload: {
                    filteredEndTime: value
                }
            });
        };
    },
    updateInitialState: function (initialState) {
        return function (dispatch) {
            dispatch({
                type: UseShiftFilterActionType.UpdateInitialState,
                payload: __assign({}, initialState)
            });
        };
    },
    resetFilters: function (initialState) {
        return function (dispatch) {
            BIAnalytics.resetFilters();
            BIAnalytics.updateFilterOnFindShiftsPage();
            dispatch({
                type: UseShiftFilterActionType.ResetFilters,
                payload: __assign({}, initialState)
            });
        };
    }
};
export var reducer = function (state, _a) {
    var type = _a.type, payload = _a.payload;
    var result = {};
    switch (type) {
        case UseShiftFilterActionType.UpdateLocationFilter:
        case UseShiftFilterActionType.UpdateTypeFilter:
        case UseShiftFilterActionType.UpdateUnavailableFilter:
        case UseShiftFilterActionType.UpdateTimeStartFilter:
        case UseShiftFilterActionType.UpdateTimeEndFilter:
        case UseShiftFilterActionType.UpdateInitialState:
            result = __assign(__assign({}, state), payload);
            break;
        case UseShiftFilterActionType.ResetFilters:
            var initialState = payload;
            // manually reset the state
            result = {
                filteredLocations: resetMapValues(initialState.filteredLocations, true),
                locationLabels: initialState.locationLabels,
                filteredTypes: resetMapValues(initialState.filteredTypes, false),
                filteredUnavailabilityOpts: resetMapValues(initialState.filteredUnavailabilityOpts, false),
                filteredStartTime: undefined,
                filteredEndTime: undefined,
                filteredJobTypes: resetMapValues(initialState.filteredJobTypes, true)
            };
            break;
        default:
            throw new Error("No reducer defined for type ".concat(type, " in useShiftState"));
    }
    return result;
};
function resetMapValues(data, value) {
    var newMap = {};
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        newMap[key] = value;
    }
    return newMap;
}
export var useShiftFilters = function (_a) {
    var _b;
    var loadFilterState = _a.loadFilterState, loadLegacyFilterState = _a.loadLegacyFilterState, shiftOpportunities = _a.shiftOpportunities, onFilterStateChange = _a.onFilterStateChange, siteParam = _a.siteParam;
    var storedState = (_b = loadFilterState()) !== null && _b !== void 0 ? _b : loadLegacyFilterState();
    var dt = useDynamicTranslation().dt;
    var locationLabels = useMemo(function () {
        var nameMap = new Map();
        if (shiftOpportunities) {
            for (var _i = 0, shiftOpportunities_1 = shiftOpportunities; _i < shiftOpportunities_1.length; _i++) {
                var opportunity = shiftOpportunities_1[_i];
                nameMap.set(opportunity.shift.site.id, opportunity.shift.site.name);
            }
        }
        return nameMap;
    }, [shiftOpportunities]);
    var initialState = useMemo(function () {
        var _a, _b, _c;
        var initialLocationState = {};
        var initialJobTypeStateSet = {};
        //if shiftOpportunities hasn't resolved return stored filter state
        if (shiftOpportunities) {
            var siteParamHasOpportunities = siteParam && locationLabels.has(siteParam);
            for (var _i = 0, _d = Array.from(locationLabels.keys()); _i < _d.length; _i++) {
                var locationId = _d[_i];
                initialLocationState[locationId] = siteParamHasOpportunities
                    ? locationId == siteParam
                    : (_a = storedState === null || storedState === void 0 ? void 0 : storedState.location[locationId]) !== null && _a !== void 0 ? _a : true;
            }
            for (var _e = 0, shiftOpportunities_2 = shiftOpportunities; _e < shiftOpportunities_2.length; _e++) {
                var opportunity = shiftOpportunities_2[_e];
                var skills = opportunity.skills;
                skills.forEach(function (skill) {
                    var _a;
                    var translatedSkill = dt(skill);
                    initialJobTypeStateSet[translatedSkill] =
                        (_a = storedState === null || storedState === void 0 ? void 0 : storedState.jobType[translatedSkill]) !== null && _a !== void 0 ? _a : true;
                });
            }
        }
        else {
            initialLocationState = (storedState === null || storedState === void 0 ? void 0 : storedState.location) || {};
            initialJobTypeStateSet = (storedState === null || storedState === void 0 ? void 0 : storedState.jobType) || {};
        }
        // If there's only one location, set it to true
        var locationKeys = Object.keys(initialLocationState);
        if (locationKeys.length === 1) {
            initialLocationState[locationKeys[0]] = true;
        }
        var unavailableShiftState = {};
        for (var _f = 0, _g = Object.keys(UnavailableShiftFilterInitialState); _f < _g.length; _f++) {
            var key = _g[_f];
            unavailableShiftState[key] =
                (storedState === null || storedState === void 0 ? void 0 : storedState.unavailable[key]) ||
                    UnavailableShiftFilterInitialState[key];
        }
        var shiftTypeState = {};
        for (var _h = 0, _j = Object.keys(ShiftTypeFilterInitialState); _h < _j.length; _h++) {
            var key = _j[_h];
            shiftTypeState[key] =
                (storedState === null || storedState === void 0 ? void 0 : storedState.shiftType[key]) || ShiftTypeFilterInitialState[key];
        }
        return {
            filteredLocations: initialLocationState,
            locationLabels: locationLabels,
            filteredTypes: shiftTypeState,
            filteredUnavailabilityOpts: unavailableShiftState,
            filteredJobTypes: initialJobTypeStateSet,
            filteredStartTime: (_b = storedState === null || storedState === void 0 ? void 0 : storedState.shiftTime) === null || _b === void 0 ? void 0 : _b.startTime,
            filteredEndTime: (_c = storedState === null || storedState === void 0 ? void 0 : storedState.shiftTime) === null || _c === void 0 ? void 0 : _c.endTime
        };
    }, [shiftOpportunities]);
    var _c = useThunkReducer(reducer, initialState), state = _c[0], dispatch = _c[1];
    var actions = {
        updateLocationFilter: function (value) {
            return dispatch(actionCreators.updateLocationFilter(value));
        },
        updateTypeFilter: function (value) {
            return dispatch(actionCreators.updateTypeFilter(value));
        },
        updateUnavailableFilter: function (value) {
            return dispatch(actionCreators.updateUnavailableFilter(value));
        },
        updateJobTypesFilter: function (value) {
            return dispatch(actionCreators.updateJobTypesFilter(value));
        },
        updateTimeStartFilter: function (value) {
            return dispatch(actionCreators.updateTimeStartFilter(value));
        },
        updateTimeEndFilter: function (value) {
            return dispatch(actionCreators.updateTimeEndFilter(value));
        },
        updateInitialState: function () {
            return dispatch(actionCreators.updateInitialState(initialState));
        },
        resetFilters: function () { return dispatch(actionCreators.resetFilters(initialState)); }
    };
    // updates state with initial state after useFindShiftsPageQuery returns opportunities
    useEffect(function () {
        actions.updateInitialState();
    }, [initialState]);
    var wrappedState = React.useMemo(function () {
        var wrappedState = {
            location: state.filteredLocations,
            shiftType: state.filteredTypes,
            unavailable: state.filteredUnavailabilityOpts,
            jobType: state.filteredJobTypes,
            shiftTime: {
                startTime: state.filteredStartTime,
                endTime: state.filteredEndTime
            }
        };
        onFilterStateChange(wrappedState);
        return wrappedState;
    }, [state]);
    var filterOptions = useShiftFilterOptions(wrappedState);
    return {
        state: wrappedState,
        filterOptions: filterOptions,
        actions: actions,
        labels: {
            locationLabels: locationLabels
        }
    };
};
var useShiftFilterOptions = function (filterState) {
    return useMemo(function () {
        var location = filterState.location, shiftType = filterState.shiftType, unavailable = filterState.unavailable, jobType = filterState.jobType;
        var locationOptions = Object.keys(location);
        var shiftTypeOptions = Object.keys(shiftType);
        var unavailableOptions = Object.keys(unavailable);
        var jobTypeOptions = Object.keys(jobType);
        return {
            location: locationOptions,
            shiftType: shiftTypeOptions,
            unavailable: unavailableOptions,
            jobType: jobTypeOptions
        };
    }, [filterState]);
};
